
import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { AuthenticationService } from "./authentication.service";



export const authResolver: ResolveFn<boolean> = (): Observable<boolean> => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.verifyActiveToken().pipe(
    tap(isAuthenticated => {
      if (!isAuthenticated) {
        router.navigate(['/account/login']);
      }
    })
  );
};